if (!Enum) {
    var Enum = {};
}

Enum.EXPORT_TYPE = {
    FULL_PROFILE: 'FULL_PROFILE',
    STATE_OF_HEALTH: 'STATE_OF_HEALTH',
    VISIT_LIST: 'VISIT_LIST',
    PERSONAL_DATA: 'PERSONAL_DATA',
    PATIENT_ATTACHMENTS: 'PATIENT_ATTACHMENTS',
    OFFICE_DATA: 'OFFICE_DATA'
};

Object.freeze(Enum.EXPORT_TYPE);